// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__M1hyy","content":"style_content__dbaaC"};